import { render, staticRenderFns } from "./MyClassCard.vue?vue&type=template&id=c33859b4&scoped=true&"
import script from "./MyClassCard.vue?vue&type=script&lang=ts&"
export * from "./MyClassCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyClassCard.vue?vue&type=style&index=0&id=c33859b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33859b4",
  null
  
)

export default component.exports